export const FlowStatusEnum = {
  REJECTED: 0,
  FINISH: 1,
  APPROVING: 2,
  WITHDRAW: 3,
  DRAFT: 9
};

export const FlowNodeStatusEnum = {
  NOT_START: "",
  REJECTED: "0",
  AGREED: "1",
  ACTIVE: "2",
  STARTED: "3",
  RESTART: "4",
  WITHDRAW: "5",
  SUSPENDED: "9"
};

